import React from 'react';
import { idToDate } from '../../utils/timeline/dateFns';
import { type Moment } from 'moment';
import { type RecordId } from '../../types';

const div = document.createElement('div');

export interface DrawerContentsProps {
  title?: string;
  titleHTML?: string;
  recordId?: RecordId;
  createdAt?: Moment;
  color?: string;
  children: React.ReactNode;
}

const DrawerContents: React.FC<DrawerContentsProps> = ({
  title,
  titleHTML,
  recordId,
  createdAt,
  color = 'var(--aha-pink-700)',
  children,
}) => {
  if (recordId) {
    createdAt ||= idToDate(recordId);
  }

  if (!title) {
    if (titleHTML) {
      // TODO: memoization and/or security
      div.innerHTML = titleHTML;
      title = div.textContent!;
    } else {
      title = 'Whiteboard';
    }
  }

  return (
    <div id='tabbed-record-contents' className='content'>
      <div className='details tabbed-drawer tabbed-record '>
        <div className='drawer-nav' style={{ borderTopColor: color }}>
          <div className='drawer-nav__row details__name--row'>
            <div className='m-0 mt-3 details__name'>{title}</div>
          </div>
        </div>
        <div className='drawer-contents tabbed-record__scroll-container'>
          {createdAt && (
            <div className='details__created-by'>
              Created on {createdAt.format('MMM D, YYYY')}
            </div>
          )}
          {children}
        </div>
      </div>
    </div>
  );
};

export default DrawerContents;
